import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import SideMenu from './components/SideMenu';
import Overview from './components/Overview';
import { formatDate, nowTime } from '@/utils/date';
export default {
  components: {
    SideMenu: SideMenu,
    Overview: Overview
  },
  data: function data() {
    return {
      timer: null,
      thisTime: '',
      alarmMusic: '',
      currentTime: '',
      showModel: true,
      mapSrc: '/web/static/index.html',
      // 地图路径
      selectedIndex: 0,
      showSideMenu: false,
      warnBoxVisible: false,
      activeView: 'Overview',
      // 当前选中的导航菜单
      roleId: {},
      userName: '',
      checkIndex: 1,
      fullscreen: false,
      showDeviceType: -1,
      isSuper: 0,
      creenClose: false,
      viewList: ['Overview', 'BASystem', 'CommunityService', 'PinganDistrict', 'PartyBuilding'],
      menuList: [{
        title: '小区总览',
        icon: 'sqzl'
      }, {
        title: 'BA系统',
        icon: 'baxt'
      }, {
        title: '小区服务',
        icon: 'sqfw'
      }, {
        title: '平安小区',
        icon: 'paxq'
      }, {
        title: '小区党建',
        icon: 'sqdj'
      }]
    };
  },
  computed: _objectSpread({
    todayDate: function todayDate() {
      var date = formatDate(new Date(Date.now()), 'yyyy-MM-dd').toString(); // 今天的日期

      var week = '星期' + '日一二三四五六'.charAt(new Date().getDay());
      return date + ' ' + week + ' ' + this.currentTime;
    }
  }, mapState({
    realFilter: function realFilter(state) {
      return state.user.realFilter;
    }
  })),
  created: function created() {
    var _this = this;

    var showModel = this.$route.query.showModel;
    if (showModel) this.showModel = false;
    this.timer = setInterval(function () {
      _this.currentTime = nowTime();
    }, 1000); // this.alarmMusic = new Audio('/static/audios/4123.wav')

    window.onresize = function () {
      return function () {
        document.getElementById('mapBox').innerHTML = '<iframe id="MapMain" style="width: 100%;height: 100%;border:0px;" src=' + _this.mapSrc + '></iframe>';
      }();
    }; // setInterval(() => {
    //   this.getRealTimeAlarm()
    // }, 20000)
    // this.getRealTimeAlarm()
    // // this.loadData()
    // this.getThisTime()

  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    handleMapMessage: function handleMapMessage(systemType) {
      console.log('systemType', systemType);
      var obj = {
        Func: 'ShowDevice',
        // 发送消息类别
        Parameter: systemType
      };
      document.getElementById('MapMain').contentWindow.frames.postMessage(obj, '*');
    },
    toggleSideMenu: function toggleSideMenu() {
      this.showSideMenu = !this.showSideMenu;
    },
    handleMenuSwitch: function handleMenuSwitch(index) {
      this.selectedIndex = index;
      this.activeView = this.viewList[this.selectedIndex];
    },
    logout: function logout() {
      var _this2 = this;

      this.$confirm('您确定要退出, 是否继续?', '提示').then(function () {
        _this2.$store.dispatch('LogOut').then(function () {
          location.reload();
        });
      });
    },
    loadData: function loadData() {
      this.userName = this.$store.getters.name;
      this.isSuper = 1;
    },
    manage: function manage() {
      this.$router.push({
        name: 'dashboard'
      });
    },
    closeDialog: function closeDialog() {
      this.checkIndex = 1;
    },
    back: function back() {
      this.checkIndex = 1;
    },
    mapHome: function mapHome() {
      this.checkIndex = 1;
      this.$refs.overview.showDeviceNew(-1);
    },
    getFullCreeen: function getFullCreeen() {
      var element = document.documentElement;

      if (this.fullscreen) {
        this.creenClose = false;

        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        this.creenClose = true;

        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }

      this.fullscreen = !this.fullscreen;
    }
  }
};